import {
	CHANGE_LAYOUT,
	CHANGE_LAYOUT_WIDTH,
	CHANGE_SIDEBAR_THEME,
	CHANGE_SIDEBAR_TYPE,
	CHANGE_TOPBAR_THEME,
	TOGGLE_RIGHT_SIDEBAR,
	SHOW_RIGHT_SIDEBAR,
	CHANGE_PRELOADER,
	HIDE_RIGHT_SIDEBAR,
	SEARCH_SELECTION,
	GET_LOGO,
	SET_LOGO
} from "./actionTypes";

import {
	HORIZONTAL, VERTICAL
} from "./constants";

// interface IAction {
// 	type: string;
// 	payload: any;
// }

export type LayoutType = typeof HORIZONTAL | typeof VERTICAL;

export const changeLayout = (layout:any) => ({
	type: CHANGE_LAYOUT,
	payload: layout
});

export const changePreloader = (layout: boolean) => ({
	type: CHANGE_PRELOADER,
	payload: layout
});

export const changeLayoutWidth = (width: string, layoutType: LayoutType) => ({
	type: CHANGE_LAYOUT_WIDTH,
	payload:  { width, layoutType }
});

export const changeSidebarTheme = (theme:string, layoutType: LayoutType) => ({
	type: CHANGE_SIDEBAR_THEME,
	payload: {theme, layoutType}
});

export const changeSidebarType = (sidebarType: string, isMobile:boolean) => {
	return {
		type: CHANGE_SIDEBAR_TYPE,
		payload: { sidebarType, isMobile }
	};
};

export const changeTopbarTheme = (topbarTheme:string) => ({
	type: CHANGE_TOPBAR_THEME,
	payload: topbarTheme
});


export const toggleRightSidebar = () => ({
	type: TOGGLE_RIGHT_SIDEBAR,
	payload: null
});

export const showRightSidebar = () => ({
	type: SHOW_RIGHT_SIDEBAR,
	payload: null
});

export const hideRightSidebar = () => ({
	type: HIDE_RIGHT_SIDEBAR,
	payload: null
});

export const searchSelection = (value: string, term: string) => ({
	type: SEARCH_SELECTION,
	searchSelection: value,
	term: term,
	payload: true
});

export const getLogo = () => ({
	type: GET_LOGO
});

export const setLogo = (logo : string) => ({
	type: SET_LOGO,
	payload: logo
});